import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";

const NotFound = ({ t }: WithTranslation) => (
    <MenuItem key={"notfound"} component="div" disabled>
        <em>{t("Autocomplete.NotFound.label")}</em>
    </MenuItem>
);

export default withTranslation()(NotFound);
